module.exports = __webpack_public_path__ + "static/media/boxing_bell.4bbd4955.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/boxing_bell.mp3
// module id = 37
// module chunks = 0